import { render, staticRenderFns } from "./MortgagePickerHandler.vue?vue&type=template&id=23da3621&scoped=true&"
import script from "./MortgagePickerHandler.vue?vue&type=script&lang=js&"
export * from "./MortgagePickerHandler.vue?vue&type=script&lang=js&"
import style0 from "./MortgagePickerHandler.vue?vue&type=style&index=0&id=23da3621&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da3621",
  null
  
)

export default component.exports